import TimeIcon from "app/components/Icons/TimeIcon";
import CustomTooltip from "app/components/Tooltip";
import EffortEstimatedInput from "app/containers/Features/components/EffortEstimatedInput";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { formatEffortShorthand } from "app/containers/Features/helper";
import { EffortEstimatedType } from "app/containers/Features/types";
import { selectUserFormData } from "app/redux/selector";
import React, { FC, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IDashboardUserTicket } from "../type";

interface CustomProps {
  row: IDashboardUserTicket;
  onUpdate: (effortEstimated: EffortEstimatedType) => void;
}

const EffortEstimated: FC<CustomProps> = ({ row, onUpdate }) => {
  const [edit, setEdit] = useState(false);
  const { effortEstimated } = row;

  const { _id: userId } = useSelector(selectUserFormData);
  const projectMembers = useSelector(selectProjectMemberList);

  const member = useMemo(() => {
    return projectMembers.find((member) => member.userId === userId);
  }, [projectMembers, userId]);

  const assigneeKey = member?._id ?? userId;
  const currentEffortEstimated = useMemo(
    () =>
      effortEstimated?.find(
        (effect) =>
          effect.memberId === member?._id || effect.memberId === userId,
      ),
    [effortEstimated, member?._id, userId],
  );
  const formattedEffort = currentEffortEstimated
    ? formatEffortShorthand(
        currentEffortEstimated?.effort?.hours,
        currentEffortEstimated?.effort?.minutes,
      )
    : "";

  return (
    <div className="flex h-full items-center whitespace-nowrap px-4 text-black">
      {edit ? (
        <EffortEstimatedInput
          setEdit={setEdit}
          effortEstimated={row.effortEstimated}
          ticketAssignee={assigneeKey}
          onUpdate={onUpdate}
        />
      ) : (
        <CustomTooltip
          text="Set efforts estimation"
          className="flex items-center justify-start w-full p-1.5 hover:bg-white rounded truncate"
          position="left"
        >
          <button
            type="button"
            className="flex items-center gap-1 w-full truncate"
            onClick={() => setEdit(true)}
            disabled={!userId}
          >
            <TimeIcon size={18} />
            <span className="text-sm font-normal text-secondary truncate">
              {formattedEffort.length > 0
                ? formattedEffort
                : "Enter efforts estimation"}
            </span>
          </button>
        </CustomTooltip>
      )}
    </div>
  );
};

export default EffortEstimated;
